import { Layers, Wrench } from "lucide-react";
import { SectionHead, FadeUp } from "@/components/site/Reveal";
import { BRANDS } from "@/data/site";

const ICONS = { tray: Layers, hardware: Wrench };

const Mark = ({ b }) => {
  if (b.logo) {
    return <img src={b.logo} alt={`${b.name} logo – available at Rama Electricals, Goregaon East`} loading="lazy"
      className={`max-h-12 max-w-[78%] w-auto object-contain ${b.invert ? "invert" : ""}`} />;
  }
  const Icon = ICONS[b.icon];
  return Icon
    ? <Icon size={36} className="text-[#030712]" strokeWidth={1.5} />
    : <span className="font-display text-2xl font-bold text-[#030712] tracking-tight">{b.name}</span>;
};

export const BrandWall = () => (
  <section className="px-6 py-28" data-testid="brand-wall-section">
    <div className="mx-auto max-w-7xl">
      <SectionHead eyebrow="Brands we carry" title={["Names you trust,", "all under one roof."]}
        text="Rama Electricals is a primary dealer for Legrand, Polycab and L&K, and stocks a wide range of other leading electrical brands." />
      <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-4">
        {BRANDS.map((b, i) => (
          <FadeUp key={b.name} delay={(i % 4) * 0.06} data-testid={`brand-tile-${i}`}
            className={`group glass rounded-3xl p-3 transition-colors duration-300 hover:border-[#39FF14]/50 ${b.primary ? "border-[#39FF14]/40" : ""} ${b.icon ? "md:col-span-2" : ""}`}>
            <div className="relative h-28 md:h-32 rounded-2xl bg-white grid place-items-center transition-transform duration-500 group-hover:scale-[0.98]">
              <Mark b={b} />
              {b.primary && <span className="absolute top-2 right-2 rounded-full bg-[#030712] px-2 py-1 font-mono text-[9px] tracking-[0.18em] text-[#39FF14]">PRIMARY</span>}
            </div>
            <div className="px-2 pt-4 pb-2">
              <h3 className="font-display text-lg leading-tight">{b.name}</h3>
              <p className="mt-1 text-xs text-[#a5b4c8]">{b.kind}</p>
            </div>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);
